export default __webpack_public_path__ + "static/media/european-union.82e25dbd.png";